<mat-form-field appearance="outline">
	<mat-label>{{ placeholder }}</mat-label>
	<!-- -->
	<input
		*ngIf="requiredField"
		class="dateInput"
		matInput
		type="text"
		[disabled]="readOnly"
		[matDatepicker]="datepicker"
		[formControl]="control"
		[name]="control.name"
		[min]="min"
		[max]="max"
		[errorStateMatcher]="matcher"
		required="requiredField"
		(click)="inputCanClickable ? datepicker.open() : ''"
	/>
	<input
		*ngIf="!requiredField"
		class="dateInput"
		matInput
		type="text"
		[disabled]="readOnly"
		[matDatepicker]="datepicker"
		[formControl]="control"
		[name]="control.name"
		[min]="min"
		[max]="max"
		[errorStateMatcher]="matcher"
		(click)="inputCanClickable ? datepicker.open() : ''"
	/>

	<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
	<button
		mat-button
		*ngIf="control.value && showClearButton"
		matSuffix
		mat-icon-button
		aria-label="Clear"
		(click)="control.setValue(null)"
	>
		<mat-icon>close</mat-icon>
	</button>

	<mat-datepicker touchUi #datepicker></mat-datepicker>

	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-form-field>
